const scope = "tte";
export default scope;
